<template>
  <div>
    <div class="left">
      <google-map/>
    </div>
    <div class="right">
      <vehicle v-show="!isViewHistoryDetail"/>
      <history-detail v-if="isViewHistoryDetail"/>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import Vehicle from '@/pages/vehicle/components/List';
import GoogleMap from '@/pages/map/components/map';
import HistoryDetail from '@/pages/map/components/historydetail';
import { mapGetters } from 'vuex';

export default {
  components: {
    Vehicle,
    GoogleMap,
    HistoryDetail
  },
  computed: {
    ...mapGetters(['isViewHistoryDetail'])
  }
};
</script>
<style scoped>
.left {
  width: calc(100% - 400px);
  height: calc(100vh - 64px);
}
.right {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/map/index.vue